import { render } from "./SplashZone.vue?vue&type=template&id=426ce863&scoped=true"
import script from "./SplashZone.vue?vue&type=script&lang=js"
export * from "./SplashZone.vue?vue&type=script&lang=js"

import "./SplashZone.vue?vue&type=style&index=0&id=426ce863&scoped=true&lang=css"

import exportComponent from "/Users/djones/Desktop/repos/davyjones-me/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-426ce863"]])

export default __exports__